export default __webpack_public_path__ + "static/start-archi-1868bc5a6c8f805c19b7f922c8febb10.svg";